export default __webpack_public_path__ + "src/assets/img_frame_313733.258dd9c82f1750e0094eee3bc0fe112a.webp";